import { Injectable } from '@angular/core';
import Swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class ModalQueueService {
  private queue: SweetAlertOptions[] = [];
  private showing = false;

  /**
   * Encola una alerta. Si no hay ninguna mostrada, la muestra de inmediato.
   * Si hay una mostrada, espera a que se cierre para mostrarla.
   */
  enqueue(options: SweetAlertOptions) {
    this.queue.push(options);
    this.tryShowNext();
  }

  /**
   * Si no hay alerta en pantalla y hay pendientes, saca la siguiente y la muestra.
   */
  private tryShowNext() {
    if (this.showing) {
      return;
    }
    const nextOpts = this.queue.shift();
    if (!nextOpts) {
      return;
    }
    this.showing = true;
    Swal.fire(nextOpts).then(() => {
      this.showing = false;
      this.tryShowNext();
    });
  }
}
